import { render, staticRenderFns } from "./ModalEditOrderNote.vue?vue&type=template&id=127c32f2&lang=pug"
import script from "./ModalEditOrderNote.vue?vue&type=script&lang=js"
export * from "./ModalEditOrderNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports